<template>
	<v-app-bar app color="background" text-color="pink" class="rounded-b-xl pl-5 pr-5" elevate-on-scroll >
		<v-toolbar-title class="mb-1"><AppLogo /></v-toolbar-title>
		<v-spacer />
		<p class="ma-4 texto--text" style="font-size: 14px" v-if="this.catalogo">
			Total <b>R$ {{ totalCompras }}</b>
		</p>
		<v-btn text @click="click" class="d-none d-sm-flex" v-if="this.catalogo">
			<v-badge left color="green">
				<span slot="badge">{{ cartItensLength.toString().replace('.', ',') }}</span>
				<v-icon color="texto">mdi-cart</v-icon>
				<span class="texto--text">Carrinho</span>
			</v-badge>
		</v-btn>
		<v-btn text @click="click" class="d-flex d-sm-none" v-if="this.catalogo">
			<v-badge left color="green">
				<span slot="badge">{{ cartItensLength.toString().replace('.', ',') }}</span>
				<v-icon color="texto">mdi-cart</v-icon>
			</v-badge>
		</v-btn>
	</v-app-bar>
</template>
<script>
import AppLogo from '../widgets/AppLogo'
import { mapState, mapGetters } from 'vuex'
import convertDinheiro from '@/mixins/methods/convertDinheiro'

export default {
	components: { AppLogo },
	data: function () {
		return {
			idPedido: 0,
		}
	},
	methods: {
		click() {
			this.goCheckout()
		},
		goCheckout() {
			if (this.$router.history.current.name !== 'Checkout')
				this.$router.push(`/${this.catalogo.identificadorCatalogo}/checkout${this.retornarQueryVendedor()}`)
		},
	},
	computed: {
		...mapState(['user']),
		...mapGetters({
			cartProducts: 'cartProducts',
			cartLength: 'cartLength',
			catalogo: 'catalogo',
		}),
		cartItensLength() {
			return this.cartLength
		},
		totalCompras() {
			var ret = 0
			this.cartProducts.map((i) => {
				ret += i.valorTotal
			})
			return convertDinheiro(ret, 2)
			//ret.toFixed(2).toString().replace('.', ',')
		},
	},
}
</script>

